import { KeyboardArrowDown, KeyboardArrowUp } from '@mui/icons-material';
import { Box, Button, FormHelperText, Link, Menu, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import { cloneDeep, get, unset } from 'lodash';
import React, { FC, useEffect, useMemo, useState } from 'react';

import { set } from 'lodash';
import { useAuthentication } from 'src/context/AuthContext';
import { PostRecord } from 'src/lib/api/PostRecord';
import { APIS } from 'src/lib/constants/apis';
import { AUTH_TOKEN_DATA, NOT_FOUND_ERROR_MESSAGE } from 'src/lib/constants/constant';
import { enumT, isTrue } from 'src/utils/helper';
import CreateForm from '../form-component/create-form/CreateForm';
import LoadingBackdrop from '../loading/LoadingBackdrop';
import MuiSnackbar from '../mui-snackbar/MuiSnackbar';
import NachrichtFieldsValidator from './NachrichtFieldsValidator';

// import Schemas
import Schema from 'src/lib/paths/antrag_FULL_Paths.json';
let AP = Schema.attributes;

interface NachrichtFieldsProps {
	handleCloseDialog: () => void;
	applications: any[];
	setSendNachrichtSuccess: (value: boolean) => void;
	nachrichtId?: number;
	isReply?: boolean;
	originalTitle?: string;
	originalContent?: string;
}
const NachrichtFields: FC<NachrichtFieldsProps> = ({
	handleCloseDialog,
	applications,
	setSendNachrichtSuccess,
	nachrichtId,
	isReply,
	originalTitle,
	originalContent,
}) => {
	const { authenticatedData } = useAuthentication();
	const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
	const [loading, setLoading] = useState<boolean>(false);
	const [selectedApplication, setSelectedApplication] = useState<any>({});
	const [formValues, setFormValues] = useState<Record<string, any>>({});
	const [formErros, setFormErros] = useState<Record<string, any>>({});
	const [wsErrorMsg, setWsErrorMsg] = useState<string>('');

	const applicationLists = useMemo(() => {
		if (applications.length > 0) return applications;
		else return [];
	}, [applications]);

	const handleInputChange = (path: string, value: any) => {
		setFormValues((prevValue) => ({
			...prevValue,
			[path]: value,
		}));
		let errorObject = cloneDeep(formErros);
		unset(errorObject, path);
		setFormErros(errorObject);
	};

	const validateFormValues = () => {
		let errorObj = {};
		let errs = NachrichtFieldsValidator.validate(formValues);
		for (let error of errs) {
			set(errorObj, error.path, get(error, 'message', ''));
		}
		setFormErros(errorObj);
		return Object.keys(errorObj).length === 0;
	};

	const handleSendNachricht = async () => {
		if (validateFormValues()) {
			const data = {
				data: {
					...formValues,
					Allgemein_Ordner: 'Postausgang',
					Antragsteller: get(authenticatedData, AUTH_TOKEN_DATA.organisationId),
					Allgemein_Erstellt: new Date(),
					Urspruengliche_Nachricht: isTrue(isReply) ? nachrichtId : null,
				},
			};
			if (isReply) set(data, 'data.UrspruenglicheNachricht', nachrichtId);
			setLoading(true);
			try {
				const res = await PostRecord(APIS['Portal-Nachricht'], data);
				let pushNotificationdata = { data: { entities: [{ api: 'nachrichts', id: get(res, 'data.id') }] } };
				await PostRecord(APIS.PushNotificaiton, pushNotificationdata);
				if (res) setSendNachrichtSuccess(true);
			} catch (err: any) {
				console.error('ERROR Saving Nachrichten ', err);
				setWsErrorMsg(err.message);
			} finally {
				handleCloseDialog();
				setLoading(false);
			}
		}
	};

	useEffect(() => {
		if (applicationLists.length) {
			if (applicationLists.length === 1) {
				setSelectedApplication(applicationLists[0]);
			}
			// Setting Initial Values
			setFormValues(() => ({
				Foerderantrag: applicationLists.length === 1 ? get(applicationLists[0], 'id') : null,
				Foerderprogramm: applicationLists.length === 1 ? get(applicationLists[0], `${AP.Foerderprogramm.path}.id`) : null,
				Allgemein_Betreff: isReply ? `Re: ${originalTitle}` : '',
				Allgemein_Inhalt:
					originalContent ?
						`${'\n\n-------------------------------------- Ursprüngliche Nachricht --------------------------------------\n' + originalContent}`
					:	'',
			}));
		}
		setLoading(false);
	}, [applicationLists, isReply, originalContent, originalTitle]);

	console.log(' application lists  ', applicationLists);
	console.log(' form values  ', formValues);
	console.log(' selected application  ', selectedApplication);

	if (loading) return <LoadingBackdrop />;
	return (
		<>
			<MuiSnackbar
				showSnackbar={Boolean(wsErrorMsg)}
				closeSnackbar={() => setWsErrorMsg('')}
				alertMessage={wsErrorMsg || NOT_FOUND_ERROR_MESSAGE}
				error={true}
			/>
			<Stack spacing={3}>
				<Box>
					<Link
						onClick={(e) => setAnchorEl(e.currentTarget)}
						sx={{
							cursor: 'pointer',
							display: 'inline-flex',
							alignContent: 'center',
							justifyContent: 'space-between',
							minWidth: '12.82rem',
							borderBottom: `${get(formErros, 'Foerderantrag', false) ? '2px solid #d32f2f' : '2px solid'}`,
							color: `${get(formErros, 'Foerderantrag', false) ? '2px solid #d32f2f' : null}`,
						}}
					>
						An:{' '}
						{get(selectedApplication, AP.Allgemein_Projekttitel.path) ?
							`${`[${get(selectedApplication, AP.Allgemein_Eingangsnummer.path, 'ausstehend')}] ${get(selectedApplication, AP.Allgemein_Projekttitel.path)}`}`
						:	''}
						{anchorEl ?
							<KeyboardArrowUp />
						:	<KeyboardArrowDown />}
					</Link>
					{get(formErros, 'Foerderantrag', false) && <FormHelperText error>{get(formErros, 'Foerderantrag')}</FormHelperText>}

					<DropdownListApplication {...{ applicationLists, setSelectedApplication, handleInputChange, anchorEl, setAnchorEl }} />
				</Box>

				<CreateForm
					formStruc={[
						{
							fields: [
								{ path: 'Allgemein_Betreff' },
								{ type: 'text', path: 'Allgemein_Inhalt', placeholder: 'Schreiben Sie hier Ihre Nachricht' },
							],
							userProps: { direction: 'column', columnToDivide: 1 },
						},
					]}
					formValues={formValues}
					updateFormValuesFunc={handleInputChange}
					formErrors={formErros}
					api={APIS['Portal-Nachricht']}
				/>
				<Stack direction={'row'} justifyContent={'space-between'}>
					<Button variant={'outlined'} onClick={handleCloseDialog}>
						{' '}
						Abbrechen
					</Button>
					<Button onClick={handleSendNachricht}>Abschicken</Button>
				</Stack>
			</Stack>
		</>
	);
};
export default NachrichtFields;

interface DropdownListApplicationProps {
	applicationLists: any[];
	setSelectedApplication: (app: Record<string, any>) => void;
	handleInputChange: (path: string, value: any) => void;
	anchorEl: HTMLElement | null;
	setAnchorEl: (anchorEl: HTMLElement | null) => void;
}
const DropdownListApplication: FC<DropdownListApplicationProps> = ({
	applicationLists,
	setSelectedApplication,
	handleInputChange,
	anchorEl,
	setAnchorEl,
}) => {
	const handleApplicationSelect = (app: Record<string, any>) => {
		setSelectedApplication(app);
		handleInputChange('Foerderantrag', get(app, 'id'));
		handleInputChange('Foerderprogramm', get(app, `${AP.Foerderprogramm.path}.id`));
		setAnchorEl(null);
	};
	return (
		<>
			<Menu
				open={Boolean(anchorEl)}
				anchorEl={anchorEl}
				onClose={() => setAnchorEl(null)}
				MenuListProps={{
					'aria-labelledby': 'lock-button',
					role: 'listbox',
				}}
			>
				<TableContainer key={1}>
					<Table stickyHeader aria-label='sticky header table'>
						<TableHead>
							<TableRow>
								<TableCell>Eingangsnummer</TableCell>
								<TableCell>Projekttitel</TableCell>
								<TableCell>Status</TableCell>
								<TableCell>Antragstyp</TableCell>
								<TableCell>Förderprogramm</TableCell>
							</TableRow>
						</TableHead>
						<TableBody>
							{applicationLists.map((ele, i) => (
								<TableRow key={i} hover onClick={() => handleApplicationSelect(ele)}>
									<TableCell>{get(ele, AP.Allgemein_Eingangsnummer.path)}</TableCell>
									<TableCell>{get(ele, AP.Allgemein_Projekttitel.path)}</TableCell>
									<TableCell>{enumT(get(ele, AP.Antragstatus_Antragstatus.path))}</TableCell>
									<TableCell>{get(ele, AP.Allgemein_Typ.path)}</TableCell>
									<TableCell>{enumT(get(ele, AP.Allgemein_Antragsformular.path))}</TableCell>
								</TableRow>
							))}
						</TableBody>
					</Table>
				</TableContainer>
			</Menu>
		</>
	);
};
